import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { AvaliacaoPage } from './avaliacao.page';
import { AvaliacaoModel } from 'projects/core/src/lib/core/model/AvaliacaoModel';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';

export class AvaliacaoViewModel {

    avaliacaoModel = new AvaliacaoModel()
    context: AvaliacaoPage

    setContext(context: AvaliacaoPage) {
        this.context = context
    }

    getContext(): AvaliacaoPage {
        return this.context
    }

    async enviaAvaliacao(avaliacaoModel: AvaliacaoModel) {
        avaliacaoModel.comentario = avaliacaoModel.comentario ? avaliacaoModel.comentario : ""
        let retorno = await this.avaliacaoModel.enviaAvaliacao(avaliacaoModel)

        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                this.getContext().mensagemSucessoAlteracao('Avaliação salva com sucesso!')
            } else {
                this.getContext().mensagemFalhaAlteracao('Não foi possível salvar sua avaliação. Tente novamente')
            }
        } catch(e) {}
    }
}